import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormComponent, RadioOption, RadioGroupComponent } from '@woolworthsnz/form';
import { ProductResponse } from '@woolworthsnz/trader-api';
import { Subject, takeUntil } from 'rxjs';

export interface EachKgFormValue {
	[key: string]: ProductResponse.UnitEnum;
}

@Component({
	selector: 'product-each-kg-selector',
	template: `
		<form [formGroup]="form" cdxForm>
			<form-radio-group
				[defaultValue]="purchasingUnit"
				orientation="horizontal"
				textSize="small"
				[options]="values"
				[groupName]="'each-kg-' + uniqueId"
				a11yGroupDescription="Choose whether to order by quantity or weight"
			></form-radio-group>
		</form>
	`,
	styleUrls: ['./each-kg-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FormsModule, FormComponent, ReactiveFormsModule, RadioGroupComponent],
})
export class EachKgSelectorComponent implements OnInit, OnDestroy {
	@Input() uniqueId: number;
	@Output() unitChangeEmitter: EventEmitter<ProductResponse.UnitEnum> = new EventEmitter();
	private destroyed$: Subject<boolean> = new Subject();

	form: FormGroup;
	values: RadioOption[] = [
		{
			value: 'Kg',
			label: 'Weight',
		},
		{
			value: 'Each',
			label: 'Quantity',
		},
	];

	private _defaultPurchasingUnit: ProductResponse.UnitEnum = 'Each';
	private _purchasingUnit: ProductResponse.UnitEnum;
	get purchasingUnit(): ProductResponse.UnitEnum {
		return this._purchasingUnit ?? this._defaultPurchasingUnit;
	}

	private validRadioOptionValues = new Set(this.values.map((v) => v.value));
	@Input() set purchasingUnit(value: ProductResponse.UnitEnum) {
		this._purchasingUnit = this.validRadioOptionValues.has(value) ? value : this._defaultPurchasingUnit;
	}

	constructor(private fb: FormBuilder) {}

	ngOnInit(): void {
		this.form = this.fb.group({});
		this.form.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(this.handleFormValueChange);
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	handleFormValueChange = (e: EachKgFormValue): void => {
		this.unitChangeEmitter.emit(e[`each-kg-${this.uniqueId}`]);
	};
}
